// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PorterStoreTypes from "../PorterStoreTypes.bs.js";

function getStatusClass(status) {
  var match = PorterStoreTypes.getStatusBadgeVariant(status);
  var modifier;
  switch (match) {
    case /* BadgeSuccess */0 :
        modifier = "ps-badge--success";
        break;
    case /* BadgeError */1 :
        modifier = "ps-badge--error";
        break;
    case /* BadgeDefault */2 :
        modifier = "ps-badge--default";
        break;
    case /* BadgeWarning */3 :
        modifier = status !== 4 ? "ps-badge--warning" : "ps-badge--neutral";
        break;
    
  }
  return "ps-badge " + modifier;
}

function PorterStoreStatusBadge(Props) {
  var status = Props.status;
  return React.createElement("span", {
              className: getStatusClass(status)
            }, PorterStoreTypes.orderStatusToString(status));
}

var make = PorterStoreStatusBadge;

export {
  getStatusClass ,
  make ,
  
}
/* react Not a pure module */
